export interface IShowGPSConnectionsData {
  showConnections: boolean;
}

export const defaultShowGPSConnections: IShowGPSConnectionsData = {
  showConnections: true,
};

export const ShowGPSConnectionsStoreKey = 'show_gps_connections';
